import request from '@/utils/request';
// 获取运营商列表
let getOperatorList=(data)=>request.post('/api/operator/list',data)
// 获取运营商编码列表
let getOperatorCodeList=()=>request.get('/api/operator/getCodeList')
// 增加运营商
let addOrEditOperator=(data)=>request.post('/api/operator/add',data)
// 删除运营商
let deleteOperator=(data)=>request.get('/api/operator/delete',data)
// 获取运营商下的机型列表
let getProductList=(data)=>request.get('/api/operator/listProductNameListByOperator',data)


export default{
  getOperatorList,
  getOperatorCodeList,
  addOrEditOperator,
  deleteOperator,
  getProductList
}